<template lang="pug">
.container.py-5
  h2.text-center Product Type
  .d-none.d-sm-block
    .row.product_type.pt-2
      .col-md-4(v-for="(productType, index) in productTypeList", :key="index")
        .list
          .img(
            :style="{ backgroundImage: 'url(' + productType.photo.image + ')' }"
          )
            .d-flex.justify-content-center.align-items-center
              h3 {{ productType.title }}
          .text
            p {{ productType.content }}
            a.more(@click="moreClick(productType)", style="cursor: pointer")
              | more
              font-awesome-icon(:icon="['fas', 'caret-right']") 

  .product_type.slider.pt-4.d-block.d-sm-none
    swiper.swiper-container(:options="swiperOption", ref="mySwiper")
      swiper-slide.swiper-slide.list.text-center(
        v-for="(productType, index) in productTypeList",
        :key="index"
      )
        .img(
          :style="{ backgroundImage: 'url(' + productType.photo.image + ')' }"
        )
          .d-flex.justify-content-center.align-items-center
            h3 {{ productType.title }}
        .text
          p {{ productType.content }}
          a.more(:href="productType.link")
            | more
            font-awesome-icon(:icon="['fas', 'caret-right']") 
    .swiper_bg_arrow
      .swiper-prev.g_bg(@click="prevClick")
        font-awesome-icon(:icon="['fas', 'chevron-left']") 
      .swiper-next.g_bg(@click="nextClick")
        font-awesome-icon(:icon="['fas', 'chevron-right']") 
</template>

<script>
import { getProductTypeList } from "@/api/index";
import { mixins } from "@/mixins/mixins.js";

export default {
  name: "ProductType",
  mixins: [mixins],
  data() {
    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 1,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
      },
      productTypeList: [],
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  watch: {
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    this.initialLanguage();
  },
  methods: {
    initialLanguage() {
      this.getProductTypeList();
    },
    prevClick() {
      this.swiper.slidePrev();
    },
    nextClick() {
      this.swiper.slideNext();
    },
    getProductTypeList() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getProductTypeList(temp).then((response) => {
        this.productTypeList = response.data;
      });
    },
    moreClick(productType) {
      this.linkClick(productType.link);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/home/product_type";
</style>
